export default __webpack_public_path__ + "static/media/razorpay-logo.72517517.png";